<template>
    <div class="modal" style="margin-top:50px;background:rgba(0,0,0,0.5);z-index:9999999;position:absolute;top:-50px;" 
         :style="{display:show?'block':'none'}">
        <div style="position:relative;width:100%;margin:0 auto;border-radius:10px;padding:10px;margin-top:20px;">

            <div class="pbcss-loading-bg-gif">
                
            </div>  

        </div>
    </div>
</template>
<script>
    export default {
        props: ['show']
    }
</script>